import { useState } from 'react';
import { Dialog } from '@mui/material';
import RecordSearchView from 'elements/RecordSearchView';
import HeaderModal from 'pages/MarketingPage/Components/HeaderModal';
import { toast } from 'react-toastify';
import { TOAST_OPTIONS } from 'components/Navbar/Components/AdminOptions';
import { forceRelease_api } from 'api/campaignApi';
import useScreen from 'Hooks/useScreen';
import { toastError } from 'modules/Toast';
import { RecordDetails } from 'modules/Types';
import { makeStyles } from "@material-ui/core";

interface ManuallyReleaseModalProps {
    open: boolean;
    contentSlug: string;
    onClose: () => void;
    refreshCampaignDetails: () => void;
}

export const ManuallyReleaseModal = ({
    open,
    contentSlug,
    onClose,
    refreshCampaignDetails,
}: ManuallyReleaseModalProps) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false)
    const { mobileView } = useScreen();

    const onReleaseSelected = async (spotifyId: string) => {
        setLoading(true)
        const response = await forceRelease_api(contentSlug, spotifyId)
        if (response) {
            toast.success('Content successfully released', TOAST_OPTIONS)
        } else {
            toastError('Error releasing content.')
        }
        setLoading(false)
        await refreshCampaignDetails()
        onClose()
        return;
    }

    const handleSelectRecord = async (brandContent: RecordDetails) => {
        const { spotify_id } = brandContent;
        await onReleaseSelected(spotify_id)
    }

    return (
        <Dialog open={open} PaperProps={{ className: classes.paper }} fullWidth={mobileView}>
            <HeaderModal
                closeModal={onClose}
                title='Find your release'
                subtitle='Select the release you want to promote'
            />
            <RecordSearchView
                parentLoading={loading}
                letUserSearchSpotify
                handleSelectRecord={handleSelectRecord}
                options={['single', 'project']}
            />
        </Dialog>
    );
};


export const useStyles = makeStyles(() => ({
    paper: {
        width: '50%',
        height: 'fit-content',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
}));